import { useState } from "react";
import { colors } from "../../../constants/colors";

function SubmitConfirmAlert({ isVisible, setIsVisible, handleSubmit }) {
  const display = isVisible ? "flex" : "none";
  const [isBot, setIsBot] = useState(false);

  const confirmClicked = (e) => {
    if (isBot) return;
    e.preventDefault();
    setIsVisible(false);
    handleSubmit();
  };

  const cancelClicked = (e) => {
    e.preventDefault();
    setIsVisible(false);
  };

  const Styles = {
    confirmBg: {
      position: "fixed",
      display: display,
      left: 0,
      top: 0,
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(50, 50, 50, 0.3)",
      overflow: "hidden",
      zIndex: 3,
    },
    alert: {
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "white",
      padding: "3rem 4rem",
      borderRadius: 10,
    },
    button: {
      margin: 5,
      backgroundColor: colors.primary,
    },
    title: {
      fontSize: "1rem",
      fontWeight: "500",
      marginBottom: "1rem",
    },
    buttons: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    check: {
      position: "fixed",
      width: "15rem",
      right: "2000vw",
    },
  };

  return (
    <div style={Styles.confirmBg}>
      <div style={Styles.alert}>
        <div style={Styles.title}>Are you ready to submit the form?</div>
        <select
          aria-label="do not make a selection"
          style={Styles.check}
          onChange={(e) => setIsBot(e.target.value !== "")}
        >
          <option value="" selected={true} disabled></option>
          <option value="ready">I'm ready</option>
          <option value="notReady">I'm not ready</option>
          <option value="doNotKnow">I don't know</option>
        </select>
        <span style={Styles.buttons}>
          <button
            type="button"
            style={Styles.button}
            onClick={(e) => confirmClicked(e)}
          >
            Confirm
          </button>
          <button
            type="button"
            style={Styles.button}
            onClick={(e) => cancelClicked(e)}
          >
            Cancel
          </button>
        </span>
      </div>
    </div>
  );
}

export default SubmitConfirmAlert;
